import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Reviews = () => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [formData, setFormData] = useState({ name: '', role: '', message: '' });
  const navigate = useNavigate();

  // Updated reviews to match the exact content from the screenshots
  const reviews = [
    { name: "Rahul Sharma", role: "Web Development Intern", text: "\"Completing the assignments helped me understand real development workflows. The projects I submitted are now part of my portfolio.\"", stars: 5, initial: "R" },
    { name: "Priya Singh", role: "App Development Intern", text: "\"I built a functional Android app as part of my assignment. This practical experience gave me the confidence to apply for jobs.\"", stars: 5, initial: "P" },
    { name: "Amit Patel", role: "Data Science Intern", text: "\"Working on real-world datasets for my assignments was a game changer. I now have a solid data science portfolio to show recruiters.\"", stars: 4, initial: "A" },
    { name: "Sneha Gupta", role: "UI/UX Design Intern", text: "\"The design assignments were challenging and practical. Earning the verified certificate validated my skills in UI/UX.\"", stars: 5, initial: "S" },
    { name: "Vikram Malhotra", role: "Cyber Security Intern", text: "\"The network security tasks simulated real scenarios. Completing these assignments proved my skills far better than just watching tutorials.\"", stars: 5, initial: "V" },
    { name: "Ananya Sharma", role: "Frontend Developer Intern", text: "\"CodeAlpha provided the perfect platform to master React and Tailwind CSS. The real-world projects were top-notch!\"", stars: 5, initial: "A" }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if(rating === 0 || !formData.name || !formData.message) {
      alert("Please fill all details and provide a rating.");
      return;
    }
    alert("Thank you for your feedback!");
    setFormData({ name: '', role: '', message: '' });
    setRating(0);
  };

  return (
    <>
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&display=swap');`}
      </style>
      <main className="pt-[140px] pb-20 bg-[#f8fafc] dark:bg-slate-950 min-h-screen font-sans">
        <div className="max-w-[1200px] mx-auto px-5">
          
          {/* Header Section */}
          <div className="text-center mb-16 animate-in fade-in slide-in-from-top-4 duration-700">
            <span className="text-[#0284C7] text-[12px] font-bold uppercase tracking-[1.5px] mb-4 block">
              Community Voices
            </span>
            <h1 className="text-[40px] md:text-[56px] font-medium text-[#0F172A] dark:text-white mb-6 leading-tight tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Student <span className="text-[#2DD4BF]">Feedback</span>
            </h1>
            <p className="text-[#64748B] dark:text-slate-400 text-[16px] md:text-[17px] max-w-2xl mx-auto font-medium leading-relaxed">
              See what our interns have to say about their journey with CodeAlpha. Your experience matters to us.
            </p>
          </div>

          {/* Reviews Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-24">
            {reviews.map((review, index) => (
              <div key={index} className="bg-white dark:bg-slate-900 rounded-[24px] p-[30px] border border-slate-100 dark:border-slate-800 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:-translate-y-1 transition-transform duration-300 flex flex-col h-full">
                
                {/* Quote Icon */}
                <div className="mb-4">
                  <svg width="45" height="45" viewBox="0 0 24 24" fill="currentColor" className="text-[#bae6fd] dark:text-slate-800">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                  </svg>
                </div>
                
                <div className="relative flex-grow">
                  <p className="text-[#475569] dark:text-slate-300 font-medium leading-relaxed text-[15px] mb-6">
                    {review.text}
                  </p>
                </div>
                
                {/* Separator */}
                <div className="w-full h-[1px] bg-slate-100 dark:bg-slate-800 mb-5"></div>
                
                {/* Card Footer (Avatar, Name, Role, Stars) */}
                <div className="flex items-center gap-3">
                  <div className="w-[42px] h-[42px] rounded-full bg-[#e0f2fe] text-[#0284c7] font-bold flex items-center justify-center text-[16px] shrink-0">
                    {review.initial}
                  </div>
                  
                  <div className="flex flex-col flex-grow">
                    <h4 className="font-bold text-[#0F172A] dark:text-white text-[15px]">{review.name}</h4>
                    <p className="text-[13px] text-[#94A3B8] font-medium">{review.role}</p>
                  </div>
                  
                  <div className="flex text-[#FACC15] gap-[2px] text-[15px]">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className={star <= review.stars ? 'text-[#FACC15]' : 'text-slate-200 dark:text-slate-700'}>
                        ★
                      </span>
                    ))}
                  </div>
                </div>

              </div>
            ))}
          </div>

          {/* Feedback Form Section */}
          <div className="bg-white dark:bg-slate-900 rounded-[32px] shadow-[0_10px_40px_rgba(0,0,0,0.06)] border border-slate-100 dark:border-slate-800 overflow-hidden flex flex-col lg:flex-row text-left max-w-[1000px] mx-auto relative">
            
            {/* Gradient Top Bar */}
            <div className="absolute top-0 left-0 w-full h-[6px] bg-gradient-to-r from-[#0ea5e9] to-[#f43f5e]"></div>
            
            {/* Left Side: Form */}
            <div className="flex-[1.3] p-10 md:p-12 lg:p-14">
              <div className="flex items-center gap-3 mb-4">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0284C7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
                <h2 className="text-[28px] md:text-[32px] font-bold text-[#0F172A] dark:text-white tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Share Your Story
                </h2>
              </div>
              
              <p className="text-[#64748B] dark:text-slate-400 font-medium mb-10 text-[14px] md:text-[15px] leading-relaxed max-w-[400px]">
                Your feedback helps us improve and guides future students. If you had a positive experience, we'd love to hear it!
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-[13px] font-bold text-[#334155] dark:text-slate-300 mb-2">Your Name</label>
                    <input 
                      type="text" 
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="w-full bg-transparent border border-slate-200 dark:border-slate-700 rounded-xl py-3 px-4 outline-none focus:border-[#0284C7] focus:ring-1 focus:ring-[#0284C7]/20 text-[15px] text-slate-800 dark:text-white transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-bold text-[#334155] dark:text-slate-300 mb-2">Your Role (e.g. Web Dev Intern)</label>
                    <input 
                      type="text" 
                      value={formData.role}
                      onChange={(e) => setFormData({...formData, role: e.target.value})}
                      className="w-full bg-transparent border border-slate-200 dark:border-slate-700 rounded-xl py-3 px-4 outline-none focus:border-[#0284C7] focus:ring-1 focus:ring-[#0284C7]/20 text-[15px] text-slate-800 dark:text-white transition-all"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-[13px] font-bold text-[#334155] dark:text-slate-300 mb-2">Your Feedback</label>
                  <textarea 
                    rows="4" 
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    className="w-full bg-transparent border border-slate-200 dark:border-slate-700 rounded-xl py-3 px-4 outline-none focus:border-[#0284C7] focus:ring-1 focus:ring-[#0284C7]/20 text-[15px] text-slate-800 dark:text-white transition-all resize-none"
                  />
                </div>

                <div>
                  <label className="block text-[13px] font-bold text-[#334155] dark:text-slate-300 mb-2">Your Rating</label>
                  <div className="flex gap-[4px] text-[28px] cursor-pointer select-none">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span 
                        key={star}
                        onMouseEnter={() => setHoverRating(star)}
                        onMouseLeave={() => setHoverRating(0)}
                        onClick={() => setRating(star)}
                        className={`transition-colors leading-none ${star <= (hoverRating || rating) ? 'text-[#FACC15]' : 'text-slate-200 dark:text-slate-700'}`}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                </div>

                <button type="submit" className="w-full mt-4 py-3.5 bg-[#0F172A] hover:bg-[#1E293B] text-white rounded-xl font-bold text-[15px] flex items-center justify-center gap-2 transition-all shadow-md active:scale-[0.98]">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                  Submit Feedback 
                </button>
              </form>
            </div>

            {/* Right Side: Thank You Panel */}
            <div className="flex-1 bg-white dark:bg-slate-900 border-t lg:border-t-0 lg:border-l border-slate-100 dark:border-slate-800 p-10 md:p-12 flex flex-col items-center justify-center text-center">
              
              <div className="mb-6">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#F43F5E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </div>
              
              <h3 className="text-[24px] md:text-[26px] font-bold text-[#0F172A] dark:text-white mb-4 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                Thank you for your contribution!
              </h3>
              
              <p className="text-[#64748B] dark:text-slate-400 text-[14px] md:text-[15px] font-medium leading-relaxed mb-8 max-w-[280px]">
                Join our community and help us build the future of tech education.
              </p>

              <button 
                onClick={() => navigate('/')}
                className="text-[#0284C7] font-bold text-[15px] flex items-center gap-2 hover:text-[#0369A1] transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
                Back to Home
              </button>
              
            </div>

          </div>
        </div>
      </main>
    </>
  );
};

export default Reviews;